import React, { FC } from 'react';
import classNames from 'classnames';

import { IAvatarProps } from '@sv-support-sdk/ui-components/src/components/Media/Avatar';

import AccountPanel from '../AccountPanel';

import css from './style.module.scss';

interface IProps {
  className?: string;
  authorName: string;
  authorAvatar: IAvatarProps;
  createdAt: string;
  message?: string;
  htmlMessage?: {
    __html: any;
  };
  authorEmail?: string;
  noLeftIndent?: boolean;
}

const Comment: FC<IProps> = ({
  className,
  authorName,
  authorAvatar,
  createdAt,
  message,
  htmlMessage,
  authorEmail,
  noLeftIndent,
}) => (
  <div className={classNames(css.comment, className)}>
    <div className={css.comment__head}>
      <AccountPanel
        tag="div"
        avatar={authorAvatar}
        title={authorName}
        info={createdAt}
        type="content"
        subtitle={authorEmail}
      />
    </div>
    {htmlMessage ? (
      <div
        className={classNames(css.comment__text, { 'indent-zero-left': noLeftIndent })}
        dangerouslySetInnerHTML={htmlMessage}
      />
    ) : (
      <div className={classNames(css.comment__text, { 'indent-zero-left': noLeftIndent })}>
        {message}
      </div>
    )}
  </div>
);

export default Comment;
